export default __webpack_public_path__ + "static/media/cprofile6.b0149ca2.png";